import { render, staticRenderFns } from "./StaffSet.vue?vue&type=template&id=30a60943&scoped=true"
import script from "./StaffSet.vue?vue&type=script&lang=js"
export * from "./StaffSet.vue?vue&type=script&lang=js"
import style0 from "./StaffSet.vue?vue&type=style&index=0&id=30a60943&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a60943",
  null
  
)

export default component.exports